import { useEffect, useState, useRef } from "react";
import {
  UPDATE_PROPERTY_BY_CLIENT_ID,
  POST_PROPERTY_FLOOR_IAMGE,
  POST_PROPERTY_COMPLIANCE_DOCS,
  GET_FLOOR_DETAILS_BY_PROPERTY_CLIENT,
  DELETE_COMPLIANCE_DOC,
  DELETE_FLOOR_PLAN_IMAGE,
  UPLOAD_PROPERTY_UPDATE_IMAGE,
} from "../api/apiPath";
import { hostName } from "../config/config";
import http from "../api/server";
import { useSelector } from "react-redux";
import FileUpload from "./common/FileUpload";
import { IconButton } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { generatePath, useParams } from "react-router-dom";

import Select from "react-select";
import ConfirmationPopup from "./common/ConfirmationPopup";
import LoadingComponent from "./common/LoadingComponent";
const UpdateProperty = (props) => {
  const {
    clientId,
    editPropertyDetails,
    blocksList,
    setRenderUpdateProperty,
    handleGetAllPropertyByClinetID,
    cityList,
    inspectorList,
    approverList,
    setToastData,
  } = props;
    const { clientNameParam } = useParams();
  //const [propertyCity, setPropertyCity] = useState(editPropertyDetails?.city);
  const [savedFloorImages, setSavedFloorImages] = useState(null);
  const [savedCompDocs, setSavedCompDocs] = useState(null);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState({
    show: false,
    headingText: "",
    infoText: "",
    cancelText: "",
    submittext: "",
  });
  const [loading, setLoading] = useState(false);
  const [floorNumberToDelete, setFloorNumberToDelete] = useState(null);
  const [loadExistingFile, setLoadExistingFile] = useState(
    editPropertyDetails?.propertyImage === null ||
      editPropertyDetails?.propertyImage === ""
      ? true
      : false
  );
  const { userObj } = useSelector((state) => state.user);
  const ImageProxyBaseUrl = hostName + "/api/Inspection/api/image?blobUrl=";
  const editPropertyBlockObj = {
    blockId:
      editPropertyDetails?.blockId === "00000000-0000-0000-0000-000000000000"
        ? null
        : editPropertyDetails?.blockId,
    blockName: editPropertyDetails?.blockName,
  };
  const [propertyName, setPropertyName] = useState(
    editPropertyDetails?.propertyName
  );
  const [propertyAddress, setPropertyAddress] = useState(
    editPropertyDetails?.propertyLocation
  );
  const [propertyPostalCode, setPropertyPostalCode] = useState(
    editPropertyDetails?.postalCode
  );
  const [propertyTotalFloor, setPropertyTotalFloor] = useState(
    editPropertyDetails?.totalNoOfFloors
  );
  const [showFloorImages, setShowFloorImages] = useState(
    editPropertyDetails?.totalNoOfFloors === null ||
      editPropertyDetails?.totalNoOfFloors === "0" ||
      editPropertyDetails?.totalNoOfFloors === 0
      ? false
      : true
  );
  const editPropertyCityObj = {
    cityId: editPropertyDetails?.cityId,
    cityName: cityList?.find(
      (city) => city.cityId.toString() === editPropertyDetails?.cityId
    )?.cityName,
  };
  const [propertyCity, setPropertyCity] = useState(editPropertyCityObj);
  const [propertyStatus, setPropertyStatus] = useState(
    editPropertyDetails?.propertyStatus
  );
  const [propertyImage, setPropertyImage] = useState(
    editPropertyDetails?.propertyImage
  );
  const [propertyBlockObj, setPropertyBlockName] =
    useState(editPropertyBlockObj);

  const [files, setFiles] = useState([]);

  const [floorEntries, setFloorEntries] = useState([
    { floor: "", image: null },
  ]);

  const [propertyInspector, setPropertyInspector] = useState(
    editPropertyDetails?.inspectors.map((inspector) => ({
      value: inspector.userId,
      label: inspector.userName ? inspector.userName : inspector.fullName,
    }))
  );
  const [propertyApprover, setPropertyApprover] = useState(
    editPropertyDetails?.approvers.map((approver) => ({
      value: approver.userId,
      label: approver.userName ? approver.userName : approver.fullName,
    }))
  );

const editPropertyFloorDetails = async () => {
    try {
      const response = await http.get(
        hostName +
          GET_FLOOR_DETAILS_BY_PROPERTY_CLIENT +
          `?propertyId=${editPropertyDetails?.propertyMasterId}&clientId=${clientId}`
      );
      if (response.status === 200) {
        console.log("floor details", response?.data);
        setSavedFloorImages(response?.data?.floorDetails || []);
        setSavedCompDocs(response?.data?.complianceDocFiles || []);
      }
    } catch (error) {
      return {};
    }
  };

  //inputrefs
  const inputRefs = {
    // block: useRef(null),
    propertyName: useRef(null),
    propertyAddress: useRef(null),
    postalCode: useRef(null),
    // totalFloor: useRef(null),
    city: useRef(null),
    inspectors: useRef(null),
    approvers: useRef(null),
    floorImages: useRef(null),
  };
  //errorObject for form validation
  const [errorObject, setErrorObject] = useState({
    // block: "",
    propertyName: "",
    propertyAddress: "",
    postalCode: "",
    city: "",
    inspectors: "",
    approvers: "",
    fileError: "",
  });

  const ukPostcodeRegex = /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2})$/i;

  const validate = () => {
    const newErrors = {};
    // if (!propertyBlockObj?.blockName) newErrors.block = "Select Block";
    if (!propertyName) newErrors.propertyName = "Property Name is required";
    if (!propertyAddress)
      newErrors.propertyAddress = "Property Address is required";
    if (!propertyPostalCode) {
      newErrors.postalCode = "Postal Code is required";
    } else if (!ukPostcodeRegex.test(propertyPostalCode.trim())) {
      newErrors.postalCode = "Invalid UK Postal Code";
    }
    // if (!propertyTotalFloor)
    //   newErrors.totalFloor = "Total floor value is required";
    if (!propertyCity?.cityName) newErrors.city = "Select City";
    if (propertyInspector && propertyInspector.length === 0)
      newErrors.inspectors = "Select at least one inspector";
    if (propertyApprover && propertyApprover.length === 0)
      newErrors.approvers = "Select at least one approver";
    for (const fe of files) {
      if (!fe.docName.trim()) {
        setError("Each file must have a document name.");
        setShowValidation(true);
        newErrors.fileError = "error in file data uploaded";
        break;
      }
      if (!fe.type) {
        setError("Each file must have a type selected.");
        setShowValidation(true);
        newErrors.fileError = "error in file data uploaded";
        break;
      }
    }
    return newErrors;
  };

  const validateFloorEntries = (cleanedFloor) => {
    const isEmptyFloorEntries = checkFloorEntries(floorEntries);
    const newFloorEntries = [...cleanedFloor];
    if (floorEntries.length > 0 && !isEmptyFloorEntries) {
      newFloorEntries.forEach((entry) => {
        if (entry.floor !== "Select" && entry.floor !== "" && !entry.image)
          entry.requireImage = "Please upload floor plan image";
        if (entry.image && (!entry.floor || entry.floor === "Select"))
          entry.requireFloor = "Please select floor";
      });
    }
    return newFloorEntries;
  };

  useEffect(() => {
    editPropertyFloorDetails();
  }, [editPropertyDetails]);

  // Options for the floor number dropdown
  const floorOptions = Array.from(
    { length: propertyTotalFloor },
    (_, i) => i + 1
  ); // Floors 1-10

  // const [availableFloorOptions, setAvailableFloorOptions ] = useState(floorOptions)

  // Function to add a new floor entry
  const handleAddFloor = () => {
    setFloorEntries([...floorEntries, { floor: "", image: null }]);
  };
  // Function to remove a floor entry by index
  const handleRemoveFloor = (index) => {
    const newFloorEntries = floorEntries.filter((_, i) => i !== index);
    setFloorEntries(newFloorEntries);
  };

  // Function to handle floor number change for a specific entry
  const handleFloorChange = (index, value) => {
    const newFloorEntries = [...floorEntries];
    newFloorEntries[index].floor = value;
    newFloorEntries[index].requireFloor = "";
    setFloorEntries(newFloorEntries);
  };

  // Function to handle image file selection for a specific entry
  const handleImageChange = (index, file) => {
    const newFloorEntries = [...floorEntries];
    newFloorEntries[index].image = file;
    newFloorEntries[index].requireImage = "";
    setFloorEntries(newFloorEntries);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setPropertyImage(file);
  };

  const [error, setError] = useState("");
  const [showValidation, setShowValidation] = useState(false);

  const uploadComplianceDocs = async (files) => {
    console.log("files", files);
    setLoading(true);
    const formDataToUploadCompliance = new FormData();
    formDataToUploadCompliance.append(
      "PropertyId",
      editPropertyDetails?.propertyMasterId
    );
    formDataToUploadCompliance.append("ClientId", clientId);
    console.log("formDataToUploadCompliance", files);
    files?.forEach((fileObj, index) => {
      formDataToUploadCompliance.append(
        `complianceDocUploadDtos[${index}].complianceType`,
        fileObj.type || 0
      );
      formDataToUploadCompliance.append(
        `complianceDocUploadDtos[${index}].complianceFileName`,
        fileObj.docName
      );
      formDataToUploadCompliance.append(
        `complianceDocUploadDtos[${index}].complianceFile`,
        fileObj.file
      ); //this is file obj
    });
    try {
      const response = await fetch(hostName + POST_PROPERTY_COMPLIANCE_DOCS, {
        method: "POST",
        body: formDataToUploadCompliance,
        headers: {
          Authorization: "Bearer " + userObj?.token,
        },
      });
      console.log("response", response, savedFloorImages);
      if (response?.status === 401) {
        window.location.href = generatePath("/client/:clientNameParam/", {
                            clientNameParam,
                          });
      }
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      } else {
        return await response.json();
      }
    } catch (error) {
      return;
    } finally {
      setLoading(false);
    }
  };

  const handelDeleteSavedCompDoc = async (fileObj) => {
    try {
      const deleteResponse = await http.delete(
        DELETE_COMPLIANCE_DOC +
          `?ComplianceDocFileID=${fileObj?.fileId}&PropertyId=${editPropertyDetails?.propertyMasterId}&ClientId=${clientId}`
      );
      if (deleteResponse.status === 200) {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Document has been successfully deleted.",
          });
        }, 2000);

        editPropertyFloorDetails();
      } else {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in deleting document, please try again.",
          });
        }, 2000);
        editPropertyFloorDetails();
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handelDeleteSavedFloorImage = async (fileObj) => {
    //const floorArr = [fileObj]
    // const formDataToDeleteFloorPlan = new FormData();
    // formDataToDeleteFloorPlan.append(
    //   "ClientId",
    //   clientId
    // );
    // formDataToDeleteFloorPlan.append("PropertyMasterId", editPropertyDetails?.propertyMasterId);
    // floorArr.forEach((floor, index) => {
    //   formDataToDeleteFloorPlan.append(`FloorNumber[${index}]`, floor);
    // })
    try {
      const deleteResponse = await http.delete(
        DELETE_FLOOR_PLAN_IMAGE +
          `?ClientId=${clientId}&PropertyMasterId=${editPropertyDetails?.propertyMasterId}&FloorNumber=${fileObj}`
      );
      if (deleteResponse.status === 200) {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Floor Plan Image has been successfully deleted.",
          });
        }, 2000);

        editPropertyFloorDetails();
      } else {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in deleting Image, please try again.",
          });
        }, 2000);
        editPropertyFloorDetails();
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const uploadPropertyimage = async () => {
    setLoading(true);
    const formDataToUploadPropertyImage = new FormData();
    formDataToUploadPropertyImage.append("ClientId", clientId);
    formDataToUploadPropertyImage.append(
      "PropertyMasterId",
      editPropertyDetails?.propertyMasterId
    );
    formDataToUploadPropertyImage.append("PropertyImage", propertyImage);
    try {
      const response = await fetch(hostName + UPLOAD_PROPERTY_UPDATE_IMAGE, {
        method: "POST",
        body: formDataToUploadPropertyImage,
        headers: {
          Authorization: "Bearer " + userObj?.token,
        },
      });
      if (response?.status === 401) {
        window.location.href =  generatePath("/client/:clientNameParam/", {
                            clientNameParam,
                          });
      }
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      } else {
        return await response.json();
      }
    } catch (error) {
      return {};
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateProperty = async (event) => {
    event.preventDefault();
    const validationErrors = validate();
    const isEmptyFloorEntries = checkFloorEntries(floorEntries);
    let isEmptyAnyFloor = false;
    let validatedFloor = floorEntries;
    if (!isEmptyFloorEntries) {
      const cleaned = validatedFloor.filter((obj) => {
        const floorValid =
          obj.floor && obj.floor.trim().toLowerCase() !== "select";
        const imageValid = obj.image && obj.image !== null;
        // Keep if at least one of the two is valid
        return floorValid || imageValid;
      });
      console.log(cleaned);
      validatedFloor = validateFloorEntries(cleaned);
      isEmptyAnyFloor = validatedFloor.some(
        (entry) => entry.requireFloor !== "" || entry.requireImage !== ""
      );
    }
    if (Object.keys(validationErrors).length > 0 || isEmptyAnyFloor) {
      if (Object.keys(validationErrors).length > 0) {
        setErrorObject(validationErrors);
        const firstErrorKey = Object.keys(validationErrors)[0];
        if (firstErrorKey && inputRefs[firstErrorKey]?.current) {
          inputRefs[firstErrorKey].current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          inputRefs[firstErrorKey].current.focus();
        }
      }
      if (isEmptyAnyFloor) {
        setFloorEntries(validatedFloor);
        const firstErrorKey = "floorImages";
        if (firstErrorKey && inputRefs[firstErrorKey]?.current) {
          inputRefs[firstErrorKey].current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          inputRefs[firstErrorKey].current.focus();
        }
      }
    } else {
      setLoading(true);

      let compResponse = [];
      if (files && files.length > 0) {
        const responseComplianceDocs = await uploadComplianceDocs(files);
        console.log("compl", responseComplianceDocs);
        if (responseComplianceDocs?.result?.isSuccess === true) {
          responseComplianceDocs?.result?.complianceDocFiles?.forEach(
            (file) => {
              const newObj = {
                complianceType: file.complianceType,
                complianceFileName: file.complianceFileName,
                complianceDocFileUrl: file.complianceDocFileUrl,
                fileId: file.fileId,
              };
              compResponse.push(newObj);
            }
          );
        }
      }
      let newPropertyImage = "";
      if (propertyImage && loadExistingFile) {
        const responsePropertyImage = await uploadPropertyimage();
        console.log("prop img", responsePropertyImage);
        if (responsePropertyImage?.result?.isSuccess === true) {
          newPropertyImage = responsePropertyImage?.result?.bloblUrl[0];
        }
      }
      const formDataToUploadProperty = new FormData();
      // formDataToUploadProperty.append(
      //   "PropertyImageFile",
      //   loadExistingFile ? propertyImage : ""
      // );
      formDataToUploadProperty.append(
        "propertyImage",
        loadExistingFile ? "" : propertyImage
      );
      formDataToUploadProperty.append("clientId", clientId);
      formDataToUploadProperty.append("propertyName", propertyName);
      formDataToUploadProperty.append("propertyLocation", propertyAddress);
      formDataToUploadProperty.append("postalCode", propertyPostalCode);
      formDataToUploadProperty.append(
        "isActive",
        editPropertyDetails?.isActive
      );
      formDataToUploadProperty.append(
        "cityId",
        propertyCity?.cityId ? propertyCity.cityId : ""
      );
      formDataToUploadProperty.append(
        "propertyMasterId",
        editPropertyDetails?.propertyMasterId
      );
      formDataToUploadProperty.append(
        "blockName",
        propertyBlockObj?.blockName ? propertyBlockObj.blockName : ""
      );
      formDataToUploadProperty.append(
        "blockId",
        propertyBlockObj?.blockId ? propertyBlockObj.blockId : ""
      );

      const selectedInspector = propertyInspector?.map((u) => u.value);
      selectedInspector.forEach((value) => {
        formDataToUploadProperty.append("inspectors[]", value); // Use '[]' in the key for server-side parsing as an array
      });
      //formDataToUploadProperty.append("InspectorIds", selectedInspector);
      const selectApprover = propertyApprover?.map((u) => u.value);
      selectApprover.forEach((value) => {
        formDataToUploadProperty.append("approvers[]", value); // Use '[]' in the key for server-side parsing as an array
      });
      if (savedCompDocs && savedCompDocs.length > 0) {
        savedCompDocs?.forEach((fileObj, index) => {
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceType`,
            fileObj.complianceType || 0
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceFileName`,
            fileObj.complianceFileName
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceDocFileUrl`,
            fileObj.complianceDocFileUrl
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].fileId`,
            fileObj.fileId
          );
        });
      } else if (compResponse.length > 0) {
        compResponse?.forEach((fileObj, index) => {
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceType`,
            fileObj.complianceType || 0
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceFileName`,
            fileObj.complianceFileName
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceDocFileUrl`,
            fileObj.complianceDocFileUrl
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].fileId`,
            fileObj.fileId
          );
        });
      } else {
        formDataToUploadProperty.append(`complianceDocs`, null);
      }
      formDataToUploadProperty.append(
        "totalNoOfFloors",
        propertyTotalFloor ? parseInt(propertyTotalFloor, 10) : null
      );
      formDataToUploadProperty.append("propertyStatus", propertyStatus);
      console.log(
        "formDataToUploadProperty",
        formDataToUploadProperty,
        selectApprover,
        selectedInspector
      );
      console.log("floorEntries", floorEntries);

      let complianceDocsPay = [];
      if (savedCompDocs && savedCompDocs.length > 0) {
        savedCompDocs.forEach((file) => {
          const newObj = {
            fileId: file.fileId,
            complianceType: file.complianceType,
            complianceFileName: file.complianceFileName,
            complianceDocFileUrl: file.complianceDocFileUrl,
          };
          complianceDocsPay.push(newObj);
        });
      }
      if (compResponse.length > 0) {
        compResponse.forEach((file) => {
          const newObj = {
            fileId: file.fileId,
            complianceType: file.complianceType,
            complianceFileName: file.complianceFileName,
            complianceDocFileUrl: file.complianceDocFileUrl,
          };
          complianceDocsPay.push(newObj);
        });
      }

      const newFormPayload = {
        clientId: clientId,
        propertyMasterId: editPropertyDetails?.propertyMasterId,
        blockName: propertyBlockObj?.blockName
          ? propertyBlockObj.blockName
          : "",
        blockId: propertyBlockObj?.blockId ? propertyBlockObj.blockId : null,
        isActive: editPropertyDetails?.isActive,
        propertyName: propertyName,
        propertyLocation: propertyAddress,
        postalCode: propertyPostalCode,
        propertyImage: loadExistingFile ? newPropertyImage : propertyImage,
        cityId: propertyCity?.cityId ? propertyCity.cityId.toString() : "",
        inspectors: selectedInspector,
        approvers: selectApprover,
        complianceDocs: [...complianceDocsPay],
        totalNoOfFloors: parseInt(propertyTotalFloor, 10) || null,
        propertyStatus: propertyStatus,
      };

      console.log("newFormPayload", newFormPayload);

      try {
        const response = await http.put(
          UPDATE_PROPERTY_BY_CLIENT_ID,
          JSON.stringify(newFormPayload)
        );
        const isEmptyFloorEntries = checkFloorEntries(floorEntries);
        console.log("update response", response, isEmptyFloorEntries);
        if (response?.status === 401) {
          window.location.href =  generatePath("/client/:clientNameParam/", {
                            clientNameParam,
                          });
        }
        if (response?.status === 200 && isEmptyFloorEntries) {
          setTimeout(() => {
            setToastData({
              toastShow: true,
              toastType: "success",
              toastString: "Property has been successfully updated.",
            });
          }, 2000);
          setRenderUpdateProperty(false);
          handleGetAllPropertyByClinetID(clientId);
        }

        if (
          response.status === 200 &&
          floorEntries?.length > 0 &&
          !isEmptyFloorEntries
        ) {
          const formDataToUploadFloorPlan = new FormData();

          // const floorPlanFiles = await Promise.all(
          //   floorEntries?.map(async (entry) => {
          //     let base64Image = "";
          //     if (entry.image) {
          //       base64Image = await fileToBase64(entry.image);
          //     }
          //     return {
          //       floorNumber: Number(entry.floor) || 0,
          //       floorImage: base64Image,
          //     };
          //   })
          // );

          floorEntries?.forEach((fileObj, index) => {
            formDataToUploadFloorPlan.append(
              `floorPlanFiles[${index}].FloorNumber`,
              Number(fileObj.floor) || 0
            );
            formDataToUploadFloorPlan.append(
              `floorPlanFiles[${index}].FloorImage`,
              fileObj.image
            ); // This is a File object
          });

          // formDataToUploadFloorPlan.append("floorPlanFiles", JSON.stringify(floorPlanFiles));
          formDataToUploadFloorPlan.append("ClientId", clientId);
          formDataToUploadFloorPlan.append(
            "PropertyMasterID",
            editPropertyDetails?.propertyMasterId
          );
          const responseFloorPlans = await fetch(
            hostName + POST_PROPERTY_FLOOR_IAMGE,
            {
              method: "POST",
              body: formDataToUploadFloorPlan,
              headers: {
                Authorization: "Bearer " + userObj?.token,
              },
            }
          );
          if (responseFloorPlans?.status === 401) {
            window.location.href =  generatePath("/client/:clientNameParam/", {
                            clientNameParam,
                          });
          }
          const responseFloorPlansData = await responseFloorPlans.json();
          if (responseFloorPlansData?.response?.isSuccess === false) {
            setTimeout(() => {
              setToastData({
                toastShow: true,
                toastType: "failure",
                toastString: "Property has not been updated, please try again.",
              });
            }, 2000);
            setRenderUpdateProperty(false);
            handleGetAllPropertyByClinetID(clientId);
          }
          if (responseFloorPlansData?.response?.isSuccess === true) {
            setTimeout(() => {
              setToastData({
                toastShow: true,
                toastType: "success",
                toastString: "Property has been successfully updated.",
              });
            }, 2000);
            setRenderUpdateProperty(false);
            handleGetAllPropertyByClinetID(clientId);
          }
        } else if (response.status === 400) {
          setTimeout(() => {
            setToastData({
              toastShow: true,
              toastType: "failure",
              toastString: response?.message,
            });
          }, 2000);
        } else {
          throw new Error(`HTTP error! status: ${response?.status}`);
        }
      } catch (error) {
        return {};
      } finally {
        setLoading(false);
      }
    }
  };

  const checkFloorEntries = (entries) => {
    const isObjectValuesEmpty = (obj) => {
      return Object.values(obj).every(
        (value) =>
          value === null ||
          value === undefined ||
          value === "" ||
          value === "Select" ||
          value === "Please select floor" ||
          value === "Please upload floor plan image"
      );
    };

    return entries.every(isObjectValuesEmpty);
  };
  const handleSelect = (e) => {
    if (e.target.name === "city") {
      const foundObject = cityList.find(
        (option) => option.cityName === e.target.value
      );
      setPropertyCity(foundObject);
    } else if (e.target.name === "block") {
      const foundObject = blocksList.find(
        (option) => option.blockName === e.target.value
      );
      setPropertyBlockName(foundObject);
    }
    setErrorObject((prevErrors) => ({
      ...prevErrors,
      [e.target.name]: e.target.value ? "" : prevErrors.totalFloor,
    }));
  };

  return (
    <>
      <div className="d-flex dashboard_body flex-column py-1 w-100">
        <div className="row m-0 p-0 mt-3 mb-2 ">
          {/* <h5 className="text-start mb-4">Update Properties</h5> */}
          <p className="text-start mb-4 fs-3 fw-bold m-0">Update Property</p>
          <div className="col-12 col-sm-6 col-lg-4 mb-2">
            <div className="form-floating mb-3">
              <select
                ref={inputRefs.block}
                className={
                  errorObject.block ? "input-error form-select" : "form-select"
                }
                name="block"
                id="floatingSelect"
                aria-label="Floating label select"
                value={propertyBlockObj?.blockName}
                onChange={(e) => {
                  handleSelect(e);
                }}
              >
                <option value="">Select Block</option>
                {blocksList?.map((data) => (
                  <option key={data?.blockId} value={data?.blockName}>
                    {data?.blockName}
                  </option>
                ))}
              </select>
              <label htmlFor="name">Block</label>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-lg-4 mb-2">
            <div className="form-floating mb-3">
              <input
                ref={inputRefs.propertyName}
                type="text"
                className={
                  errorObject.propertyName
                    ? "input-error form-control"
                    : "form-control"
                }
                id={`name1`}
                value={propertyName}
                onChange={(e) => {
                  setPropertyName(e.target.value);
                  setErrorObject((prevErrors) => ({
                    ...prevErrors,
                    propertyName: e.target.value ? "" : prevErrors.propertyName,
                  }));
                }}
              />
              <label htmlFor="name">
                Property Name
                <span style={{ color: "red" }}>*</span>
              </label>
              {errorObject.propertyName && (
                <span className="formError">{errorObject.propertyName}</span>
              )}
            </div>
          </div>

          <div className="col-12 col-sm-6 col-lg-4 mb-2">
            <div className="form-floating mb-3">
              <input
                ref={inputRefs.propertyAddress}
                type="text"
                className={
                  errorObject.propertyAddress
                    ? "input-error form-control"
                    : "form-control"
                }
                id="address"
                value={propertyAddress}
                onChange={(e) => {
                  setPropertyAddress(e.target.value);
                  setErrorObject((prevErrors) => ({
                    ...prevErrors,
                    propertyAddress: e.target.value
                      ? ""
                      : prevErrors.propertyAddress,
                  }));
                }}
              />
              <label htmlFor="address1">
                Address<span style={{ color: "red" }}>*</span>
              </label>
              {errorObject.propertyAddress && (
                <span className="formError">{errorObject.propertyAddress}</span>
              )}
            </div>
          </div>
          <div className="col-12 col-sm-6 col-lg-4 mb-2">
            <div className="form-floating mb-3">
              <input
                ref={inputRefs.postalCode}
                type="text"
                className={
                  errorObject.postalCode
                    ? "input-error form-control"
                    : "form-control"
                }
                id={`contact1`}
                value={propertyPostalCode}
                onChange={(e) => {
                  let formattedValue = e.target.value
                    .toUpperCase()
                    .replace(/\s+/g, "");
                  if (formattedValue.length > 5) {
                    formattedValue =
                      formattedValue.slice(0, -3) +
                      " " +
                      formattedValue.slice(-3);
                  }
                  setPropertyPostalCode(formattedValue);
                  setErrorObject((prevErrors) => ({
                    ...prevErrors,
                    postalCode: e.target.value ? "" : prevErrors.postalCode,
                  }));
                }}
              />
              <label htmlFor="contact1">
                Postal code
                <span style={{ color: "red" }}>*</span>
              </label>
              {errorObject.postalCode && (
                <span className="formError">{errorObject.postalCode}</span>
              )}
            </div>
          </div>
          <div className="col-12 col-sm-6 col-lg-4 mb-2">
            <div className="form-floating mb-3">
              <input
                ref={inputRefs.totalFloor}
                type="number"
                min={0}
                className={
                  errorObject.totalFloor
                    ? "input-error form-control"
                    : "form-control"
                }
                id="address"
                value={propertyTotalFloor}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  const integerValue = inputValue.replace(/[^0-9]/g, "");
                  if (integerValue > 0) {
                    setShowFloorImages(true);
                  } else {
                    setShowFloorImages(false);
                  }
                  setPropertyTotalFloor(integerValue);
                }}
              />
              <label htmlFor="address1">Total Floor</label>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-lg-4 mb-2">
            <div className="form-floating mb-3">
              <select
                ref={inputRefs.city}
                className={
                  errorObject.city ? "input-error form-select" : "form-select"
                }
                id="floatingSelect"
                value={propertyCity?.cityName}
                name="city"
                onChange={(e) => {
                  handleSelect(e);
                }}
                aria-label="Floating label select example"
              >
                <option value="">Select City</option>
                {cityList?.map((data) => (
                  <option key={data?.cityId} value={data?.cityName}>
                    {data?.cityName}
                  </option>
                ))}
              </select>
              <label htmlFor="floatingSelect">
                Select City
                <span style={{ color: "red" }}>*</span>
              </label>
              {errorObject.city && (
                <span className="formError">{errorObject.city}</span>
              )}
            </div>
          </div>
          <div className="col-12 col-sm-6 col-lg-4 mb-2">
            <div className="form-floating mb-3">
              <select
                className="form-select"
                id={`floor-select-`}
                value={propertyStatus}
                onChange={(e) => setPropertyStatus(e.target.value)}
                aria-label="Floating label select example"
              >
                <option selected value="Active">
                  Active
                </option>
                <option value="Archive">Archive</option>
              </select>
              <label htmlFor="floatingSelect">Select Property Status </label>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-lg-4 mb-2">
            <div className="form-floating mb-3">
              <Select
                ref={inputRefs.inspectors}
                isMulti
                options={inspectorList}
                value={propertyInspector}
                className={errorObject.inspectors ? "input-error" : ""}
                onChange={(e) => {
                  setPropertyInspector(e);
                  setErrorObject((prevErrors) => ({
                    ...prevErrors,
                    inspectors: "",
                  }));
                }}
                placeholder={
                  <span>
                    Select Inspector(s)
                    <span style={{ color: "red" }}>*</span>
                  </span>
                }
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  container: (base) => ({
                    ...base,
                    width: "100%",
                  }),
                  control: (base) => ({
                    ...base,
                    minHeight: "58px",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />
              {errorObject.inspectors && (
                <span className="formError">{errorObject.inspectors}</span>
              )}
            </div>
          </div>
          <div className="col-12 col-sm-6 col-lg-4 mb-2">
            <div className="form-floating mb-3">
              <Select
                ref={inputRefs.approvers}
                isMulti
                options={approverList}
                value={propertyApprover}
                className={errorObject.approvers ? "input-error" : ""}
                onChange={(e) => {
                  setPropertyApprover(e);
                  setErrorObject((prevErrors) => ({
                    ...prevErrors,
                    approvers: "",
                  }));
                }}
                placeholder={
                  <span>
                    Select Approvers(s)
                    <span style={{ color: "red" }}>*</span>
                  </span>
                }
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  container: (base) => ({
                    ...base,
                    width: "100%",
                  }),
                  control: (base) => ({
                    ...base,
                    minHeight: "58px",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />
              {errorObject.approvers && (
                <span className="formError">{errorObject.approvers}</span>
              )}
            </div>
          </div>
          <div className="col-12 col-sm-6 col-lg-4">
            {loadExistingFile && (
              <div className={`input-group customerFileBtn`}>
                <label
                  className="input-group-text"
                  // htmlFor="inputGroupFile"
                  style={{
                    height: "56px",
                    fontSize: "15px",
                    lineHeight: 2,
                  }}
                >
                  Main door Image
                </label>
                <input
                  type="file"
                  accept=".jpg, .jpeg, .png, .gif"
                  onChange={(e) => {
                    handleFileChange(e);
                  }}
                  className="form-control"
                  id="chooseFiles"
                  style={{
                    height: "56px",
                    fontSize: "16px",
                    lineHeight: 2.5,
                  }}
                />
              </div>
            )}

            {!loadExistingFile && (
              <div className="updateMainDoorDiv gap-2 d-flex align-items-justify">
                <img
                  height="150px"
                  width="180px"
                  alt="Main Door Photo"
                  className="img-fluid w-48 h-48 object-cover rounded-lg border"
                  style={{ marginTop: "5px" }}
                  src={ImageProxyBaseUrl + encodeURIComponent(propertyImage)}
                />
                <button
                  onClick={() => {
                    setLoadExistingFile(true);
                  }}
                  className="previewImageButton btn btn-primary text-center"
                >
                  <i className="fa fa-solid fa-pen"></i> Update Main Door Photo
                </button>
              </div>
            )}
          </div>
        </div>
        {showFloorImages && (
          <div className="row m-0 p-0 mt-2 mb-3">
            <div className="card bulid_card border-0">
              <div className="col-12 col-sm-10 col-lg-8 mb-3 mt-3 ps-3">
                <h5 ref={inputRefs.floorImages} className="text-start">
                  Floor Plan Images
                </h5>
              </div>
              <div className="floorplan-container">
                {savedFloorImages &&
                  savedFloorImages.length > 0 &&
                  savedFloorImages.map((floor, key) => {
                    return (
                      <div key={key} className="floorplan-item  m-1">
                        <img
                          // style={{
                          //   height: "50px",
                          //   marginTop: "5px",
                          // }}
                          src={
                            ImageProxyBaseUrl +
                            encodeURIComponent(floor?.floorImage)
                          }
                          alt="Background"
                          className="img-fluid"
                        />
                        <div className="floorplan-overlay">
                          <span className="floorplan-floor-number">
                            Floor {floor?.floorNumber}
                          </span>

                          <div className="floorplanbutton-group">
                            <i
                              className="fa-solid fa-pen-to-square pointer"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                //Need to add the Edit
                                setFloorEntries([
                                  ...floorEntries,
                                  {
                                    floor: floor?.floorNumber,
                                    image: null,
                                  },
                                ]);

                                savedFloorImages.splice(key, 1);
                                setSavedFloorImages(savedFloorImages);
                              }}
                            ></i>
                            <i
                              className="fa-solid fa-xmark pointer"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setFloorNumberToDelete(floor?.floorNumber);
                                setShowConfirmationPopup({
                                  show: true,
                                  headingText: "Delete Floor Image",
                                  infoText:
                                    "Are you sure you want to delete this floor image?",
                                  cancelText: "Cancel",
                                  submittext: "Delete",
                                });
                              }}
                            ></i>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
              {floorEntries.map((entry, index) => (
                // eslint-disable-next-line react/jsx-key
                <div className="row mt-2 ps-3">
                  <div className="col-12 col-sm-6 col-lg-5 ps-3">
                    <div className="form-floating">
                      <select
                        className={
                          entry.requireFloor
                            ? "form-select input-error"
                            : "form-select"
                        }
                        id={`floor-select-${index}`}
                        value={entry.floor}
                        onChange={(e) =>
                          handleFloorChange(index, e.target.value)
                        }
                        aria-label="Floating label select example"
                      >
                        <option selected>Select</option>
                        {floorOptions.map((floor) => {
                          const floors = floorEntries?.map(
                            (floor) => floor.floor
                          );
                          const savedF =
                            savedFloorImages?.map((floor) =>
                              floor.floorNumber.toString()
                            ) || [];
                          const combined = [...floors, ...savedF];
                          const isSelectedElsewhere =
                            combined.includes(floor.toString()) &&
                            // savedF.includes(floor.toString()) &&
                            entry.floor !== floor.toString(); // allow current selection
                          return (
                            <option
                              disabled={isSelectedElsewhere}
                              key={floor}
                              value={floor}
                            >
                              {floor}
                            </option>
                          );
                        })}
                      </select>
                      <label htmlFor="floatingSelect">Select Floor </label>
                      {entry.requireFloor && (
                        <span className="formError">{entry.requireFloor}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-5 mb-4 d-flex align-items-start justify-content-between">
                    <div className="form-floating"> <div className="d-flex gap-2">
                      <input
                        type="file"
                        accept=".jpg, .jpeg, .png, .gif"
                        className={
                          entry.requireImage
                            ? "input-error form-control"
                            : "form-control"
                        }
                        style={{
                          height: "auto",
                          // fontSize: "21px",
                          lineHeight: 1,
                        }}
                        // accept=".pdf, .dwg, .jpg, .png, .jpeg"
                        id={`image-upload-${index}`}
                        onChange={(e) =>
                          handleImageChange(index, e.target.files[0])
                        }
                      />{entry.floor && entry.floor != "Select" && <span style={{ color: "red" }}>*</span>}</div>

                      {entry.requireImage && (
                        <span className="formError">{entry.requireImage}</span>
                      )}
                    </div>
                    {/* <i
                      className="fa-solid fa-trash"
                      onClick={() => handleRemoveFloor(index)}
                    ></i> */}
                    <IconButton
                      tabIndex={0}
                      title="Delete Image"
                      onClick={() => handleRemoveFloor(index)}
                      // style={{ marginRight: "15px"}}
                    >
                      <DeleteOutlineIcon sx={{ color: "#EF3800" }} />
                    </IconButton>
                  </div>
                </div>
              ))}
              <button
                type="submit"
                className="btn btn-primary mt-2"
                style={{
                  width: "200px",
                  // fontSize: "10px",
                  marginBottom: "20px",
                }}
                onClick={() => handleAddFloor()}
                disabled={floorEntries.length == propertyTotalFloor}
              >
                <i
                  className=" fa-solid fa-plus"
                  title=" Add Floor image"
                  onClick={() => {
                    // setShowAddBlockModal(true);
                  }}
                ></i>{" "}
                Add Floor Plan Image
              </button>
            </div>
          </div>
        )}
        <div className="row m-0 p-0 mt-2 mb-3">
          <div className="card bulid_card border-0">
            <div className="row mt-3 ">
              <FileUpload
                setFiles={setFiles}
                files={files}
                setError={setError}
                error={error}
                setShowValidation={setShowValidation}
                showValidation={showValidation}
                savedCompDocs={savedCompDocs}
                handleDeleteSaved={handelDeleteSavedCompDoc}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="d-flex justify-content-end gap-4 mb-1">
            <button
              type="button"
              className="btn btn-secondary"
              style={{ width: "120px" }}
              onClick={() => {
                setRenderUpdateProperty(false);
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: "120px" }}
              onClick={handleUpdateProperty}
            >
              Update
            </button>
          </div>
        </div>
      </div>
      <LoadingComponent loading={loading} />
      <ConfirmationPopup
        show={showConfirmationPopup.show}
        headingText={showConfirmationPopup.headingText}
        infoText={showConfirmationPopup.infoText}
        cancelText={showConfirmationPopup.cancelText}
        submitText={showConfirmationPopup.submittext}
        onCancel={() => {
          setShowConfirmationPopup({
            ...showConfirmationPopup,
            show: false,
            headingText: "",
            infoText: "",
            cancelText: "",
            submittext: "",
          });
        }}
        onSubmit={() => {
          setShowConfirmationPopup({
            ...showConfirmationPopup,
            show: false,
            headingText: "",
            infoText: "",
            cancelText: "",
            submittext: "",
          });
          handelDeleteSavedFloorImage(floorNumberToDelete);
        }}
      />
    </>
  );
};
export default UpdateProperty;
